import { IconsService } from '$services/icons/icons.service';
import { PostStatus } from '$types';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-tag',
  templateUrl: './status-tag.component.html',
  styleUrls: ['./status-tag.component.css'],
})
export class StatusTagComponent {
  @Input() status!: PostStatus;
  constructor(
    private readonly icons: IconsService) {

    this.icons.registerIcon([
      `history`, `history.svg`,
      `archive`, `archive.svg`,
      `hand-stop`, `stop.svg`,
      `device-floppy`, `floppy.svg`,
      `file-upload`, `upload.svg`,])
  }
}
